import { Record, Map } from 'immutable'

export const SocketState = Record({
  userId: undefined,
  userIpAddress: undefined,
  sessionToken: undefined,
  socket: undefined,
  channels: Map(),
  state: undefined,
  authenticateStatus: undefined,
  hasConnected: false,
  reconnectStatus: Map({
    prevState: null,
  }),
  timeUntilReconnect: 0,
})

export const ChannelState = Record({
  channel: undefined,
  onMessageSubject: undefined,
  state: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/socket/models.js